import { apiRequest } from "../../../api/httpClient";

export interface CreateSceneGeoReferenceRequest {
  sourceSrid: number;
  canonicalSrid?: number;
  axisOrder: string;
  originLon: number;
  originLat: number;
  originElevationM?: number;
  bearingDeg: number;
  handedness: string;
  metersPerSceneUnit: number;
  source: string;
  checksum?: string;
  accuracyM?: number;
  capturedAt?: string;
  providedBy?: string;
  effectiveFrom: string;
  effectiveTo?: string;
}

export interface VerifySceneGeoReferenceRequest {
  expectedVersion: number;
}

export interface SceneGeoReferenceData {
  id: string;
  cemeteryId: string;
  versionNo: number;
  sourceSrid: number;
  canonicalSrid: number;
  axisOrder: string;
  originLon: number;
  originLat: number;
  originElevationM?: number | null;
  bearingDeg: number;
  handedness: string;
  metersPerSceneUnit: number;
  source: string;
  checksum?: string | null;
  accuracyM?: number | null;
  capturedAt?: string | null;
  providedBy?: string | null;
  status: string;
  effectiveFrom?: string | null;
  effectiveTo?: string | null;
  verifiedAt?: string | null;
  verifiedBy?: string | null;
  createdAt?: string | null;
  createdBy?: string | null;
  version: number;
}

export interface SceneGeoReferenceListData {
  rows: SceneGeoReferenceData[];
}

export function listSceneGeoReferences(
  cemeteryId: string,
  signal?: AbortSignal,
): Promise<{ rows: SceneGeoReferenceData[] }> {
  return apiRequest<{ rows: SceneGeoReferenceData[] }>(
    `/cemeteries/${encodeURIComponent(cemeteryId)}/scene-geo-references`,
    signal ? { signal } : {},
  );
}

export function createSceneGeoReference(
  cemeteryId: string,
  payload: CreateSceneGeoReferenceRequest,
  idempotencyKey?: string,
): Promise<SceneGeoReferenceData> {
  const headers: Record<string, string> = {
    "Content-Type": "application/json",
    "Idempotency-Key": idempotencyKey ?? `georef-create-${cemeteryId}-${Date.now()}`,
  };

  return apiRequest<SceneGeoReferenceData>(
    `/cemeteries/${encodeURIComponent(cemeteryId)}/scene-geo-references`,
    {
      method: "POST",
      headers,
      body: JSON.stringify(payload),
    },
  );
}

export function verifySceneGeoReference(
  cemeteryId: string,
  geoReferenceId: string,
  payload: VerifySceneGeoReferenceRequest,
  idempotencyKey?: string,
): Promise<SceneGeoReferenceData> {
  const headers: Record<string, string> = {
    "Content-Type": "application/json",
    "Idempotency-Key": idempotencyKey ?? `georef-verify-${geoReferenceId}-${Date.now()}`,
  };

  return apiRequest<SceneGeoReferenceData>(
    `/cemeteries/${encodeURIComponent(cemeteryId)}/scene-geo-references/${encodeURIComponent(geoReferenceId)}/verify`,
    {
      method: "POST",
      headers,
      body: JSON.stringify(payload),
    },
  );
}
